import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/uat-a/cs-mobile-next/app/components/category/CategoryContent.tsx");
;
import(/* webpackMode: "eager" */ "/home/crazysal/uat-a/cs-mobile-next/styles/category/index.module.scss");
